import $http from '../../axios-instance';
import Swal from 'sweetalert2'

export async function listarLicencia({ state, commit }, requestParameters = { params: state.filtro }) {
    await $http.get('adm_general/licencias', requestParameters)
        .then((response) => {
            commit('setListarLicencia', response.data.data)
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}
export async function listarLicenciaEmpresa({ state, commit }, requestParameters = { params: state.filtroEmpresa }) {

    await $http.get('adm_general/licencia-empresas', requestParameters)
        .then((response) => {
            commit('setListarLicenciasEmpresas', response.data)
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

export async function crearLicencia({ commit, state }) {
    await $http.post('adm_general/licencias/crear', state.selectedLicencia)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'La Licencia ha sido creada',
                showConfirmButton: true,
                timer: 5000
            })
            state.error = false
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('licenciaError', error.message)
        })
}
export async function mostrarLicencia({ commit }, id) {
    await $http.get(`adm_general/licencias/${id}`).then((response) => {
        commit('setLicencia', response.data.data)
    }).catch((error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        })
        commit('accionError', error.message)
    })
}

export async function activarLicencia({ state, commit, dispatch }, id) {
    await $http.put(`empresas/licencias/${id}`, state.selectedLicencia)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 5000
            }).then(() => {
                state.error = false
            })
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
            commit('licenciaError', error.message)
        })
}

export function setPagePagination({ commit, dispatch }, page) {
    commit('setPage', parseInt(page))
    dispatch('listarLicencia')
}